import $store from '@/store'
import VueI18n from 'vue-i18n'
import messages from '@/config/local'
import Vue from 'vue'

Vue.use(VueI18n)
const locale = $store.getters.getLocale || 'ru'

export default new VueI18n({
  locale,
  fallbackLocale: locale,
  silentTranslationWarn: true,
  messages
})
